_getPmScreen